import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsXLg } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import ConfirmModal from '#globalComponents/Overlay/ConfirmModal';

const GenerationProgress = ({ progress, onCancel, isCancelling = false, generatedCount = 0 }) => {
	const [showConfirmModal, setShowConfirmModal] = useState(false);

	const handleConfirmCancel = () => {
		setShowConfirmModal(false);
		onCancel();
	};

	return (
		<div className="bg-white border rounded-card p-4">
			<div className="flex items-center justify-between mb-2">
				<span className="text-sm font-medium text-text">Generierung läuft...</span>
				<div className="flex items-center gap-3">
					<span className="text-sm text-bgBase-800">{Math.round(progress)}%</span>
					<Button
						variant="danger"
						size="sm"
						onClick={() => setShowConfirmModal(true)}
						disabled={isCancelling}
						loading={isCancelling}
					>
						<BsXLg className="h-4 w-4" />
						{isCancelling ? 'Abbrechen...' : 'Abbrechen'}
					</Button>
				</div>
			</div>
			<div className="w-full bg-bgBase-500 rounded-full h-2">
				<div
					className="bg-primary-600 h-2 rounded-full transition-all duration-300"
					style={{ width: `${progress}%` }}
				/>
			</div>
			{generatedCount > 0 && (
				<p className="text-xs text-bgBase-800 mt-2">
					{generatedCount} E-Mail{generatedCount !== 1 ? 's' : ''} bereits generiert
				</p>
			)}

			<ConfirmModal
				isOpen={showConfirmModal}
				onClose={() => setShowConfirmModal(false)}
				onConfirm={handleConfirmCancel}
				title="Generierung abbrechen?"
				message={`Möchten Sie die Generierung wirklich abbrechen? Die bereits generierten E-Mails (${generatedCount}) werden behalten und Sie können später für die restlichen Empfänger E-Mails generieren.`}
				confirmText="Ja, abbrechen"
				cancelText="Weiter generieren"
			/>
		</div>
	);
};

GenerationProgress.propTypes = {
	progress: PropTypes.number.isRequired,
	onCancel: PropTypes.func.isRequired,
	isCancelling: PropTypes.bool,
	generatedCount: PropTypes.number,
};

export default GenerationProgress;
